import { useParams } from 'react-router-dom';
import ButtonIcon from 'components/ButtonIcon';
import Trash from 'components/icons/trash';
import Pencil from 'components/icons/pencil2';
import { Phonenumber } from 'data/firestore/phonenumber/types';
import useManagePhoneNumbers from 'data/hooks/useManagePhoneNumbers';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: Phonenumber;
    disabled?: boolean;
}

const ActionsColumn = ({
    row = {} as Phonenumber,
    disabled = false,
}: Props) => {
    const { agentId = '' } = useParams();
    const { edit, remove } = useManagePhoneNumbers({ agentId });

    return (
        <ActionsCellWrapper>
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Pencil />}
                tooltip="Edit phone number"
                size="small"
                disabled={disabled}
                onClick={() => edit(row as unknown as Phonenumber)}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Trash />}
                tooltip="Remove phone number"
                size="small"
                disabled={disabled}
                onClick={() => remove(row?.id)}
            />
        </ActionsCellWrapper>
    );
};

export default ActionsColumn;
